import * as React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Drawer from '@mui/material/Drawer';
import { IconButton } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import MenuIcon from '@mui/icons-material/Menu';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import { scrollToElement } from '../utils';

const navItems = [
  { id: '#home', name: 'Home', path: '/' },

  { id: '#services', name: 'Services', path: '/' },
  { id: '#projects', name: 'Projects', path: '/' },
  { id: '#repair-pro-tips', name: 'Repair Tips', path: '/' },
  { id: '#faq', name: "FAQ's", path: '/' },
];

export default function MobileNav() {
  const [open, setOpen] = React.useState(false);

  const [activeNavItem, setActiveNavItem] = React.useState('#home');

  const handleItemClick = (e: any, id: string) => {
    setActiveNavItem(id);
    setTimeout(() => {
      scrollToElement(id);
    }, 100);
  };

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        {navItems.map((text, index) => (
          <ListItem key={text.name} disablePadding onClick={(e) => handleItemClick(e, text.id)}>
            <ListItemButton>
              <ListItemText primary={text.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <div>
      <IconButton sx={{ p: 0, pb: 3 }} onClick={toggleDrawer(true)}>
        <MenuIcon sx={{ color: 'white', fontSize: 30 }} />
      </IconButton>

      <Drawer open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </div>
  );
}
